var exports = {
  "gM": "segmentedControlPanelGrid__RlO3XJ",
  "dh": "segmentedControlContainer__w6HNOT",
  "K": "segmentedControlButton__0E9AIA",
  "vu": "active__VkcpRh",
};

module.exports = exports;
